import(/* webpackMode: "eager" */ "/opt/build/repo/app/(chat)/updates/page.tsx");
